import React from "react";
import QuestionEditChoice from "../QuestionEditChoice";
import MatrixEditOptions from "./MatrixEditOptions";
import {Draggable, Droppable} from "react-beautiful-dnd";
import {useSelector} from "react-redux";
import {isSurveyEditRestrictedSelector} from "../../../../../../slices/surveyEditorSlice";

function MatrixColumnsChoiceEdit(props) {
    const surveyEditRestricted = useSelector(isSurveyEditRestrictedSelector);
    const hasReachedMaximumOptions = props.questionData.selects[0].options.length >= 12;

    const handleAddNewColumn = (choices) => {
        let newChoice = {
            "label": "",
            "value": (choices.length + 1).toString(),
            "disabled":false
        };
        choices.push(newChoice);
    };

    const handleRemove = (choices, idx) => {
        choices.splice(idx, 1);
        for (let index = 0; index < choices.length; index++) {
            choices[index].value = (index + 1).toString();
        }
    };

    const buildChoicesList = () => {
        const {questionData, questionValid, errorMessages, handleRemoveChoice, handleQuestionChoiceTextChange} = props;
        const questionChoices = questionData.selects[0].options;
        let htmlChoicesList;

        if (!surveyEditRestricted) {
            htmlChoicesList = questionChoices.map((choice, index) => {
                const idChoice = "selectsOptionId_" + questionData.id + "_" + choice.value + "_" + index;
                return (
                    <Draggable class="draggable" draggableId={index + "_draggables_option"} index={index}
                               key={"draggable_choice_column_item_key_" + index}>
                        {(provided) => (
                            <div ref={provided.innerRef}
                                 {...provided.draggableProps}
                                 {...provided.dragHandleProps} key={choice.value}>

                                <QuestionEditChoice
                                    idChoice={idChoice}
                                    key={idChoice}
                                    choiceText={choice.label}
                                    choiceValue={choice.value}
                                    onChange={(event) => {
                                        handleQuestionChoiceTextChange(event, index, false)
                                    }}
                                    handleRemoveChoice={(event) => {
                                        handleRemoveChoice(event, index, (selects, choiceIdx) => {
                                            selects.forEach(element => handleRemove(element.options, choiceIdx));
                                        })
                                    }}
                                    questionValid={questionValid}
                                    errorMessage={errorMessages[index]}
                                    showRemoveButton={questionChoices.length > 2}
                                    maxLength={101}
                                />
                            </div>
                        )}
                    </Draggable>
                );
            });
        } else {
            htmlChoicesList = questionChoices.map((choice, index) => {
                const idChoice = "selectsOptionId_" + questionData.id + "_" + choice.value + "_" + index;
                return (
                    <QuestionEditChoice
                        idChoice={idChoice}
                        key={idChoice}
                        choiceText={choice.label}
                        choiceValue={choice.value}
                        onChange={(event) => {
                            handleQuestionChoiceTextChange(event, index, false)
                        }}
                        handleRemoveChoice={(event) => {
                            handleRemoveChoice(event, index, (selects, choiceIdx) => {
                                selects.forEach(element => handleRemove(element.options, choiceIdx));
                            })
                        }}
                        questionValid={questionValid}
                        errorMessage={errorMessages[index]}
                        showRemoveButton={questionChoices.length > 2}
                        maxLength={101}
                    />
                );
            });
        }

        return htmlChoicesList;
    };

    const onClickAddAnswer = (event) => {
        event.preventDefault();
        props.handleAddNewChoice(event, (selects) => {
            selects.forEach(element => handleAddNewColumn(element.options));
        });
    };

    const htmlColumnsList = buildChoicesList();
    return (
        <React.Fragment>
            <div className="questionaire__builder__question__subtitle questionaire__builder__col1">
                <span>COLUMNS</span>
                {/*<a className="questionaire__builder__question__subtitle__action questionaire__builder__question__subtitle__action--addbulk"*/}
                   {/*href="#" onClick={(event) => {event.preventDefault();}}>Add answers in bulk</a>*/}
            </div>
            <div className="questionaire__builder__question__inputs">
                <div className="questionaire__builder__col1">
                    <Droppable droppableId="droppable_option" class="droppable_option" type={props.questionData.id}>
                        {(provided) => (
                            <div
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                            >
                                {htmlColumnsList}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                    {hasReachedMaximumOptions && <span className="max_columns_message">You have reached the maximum number of columns for this question</span>}
                </div>
                <div className="questionaire__builder__col2">
                    <div className="questionaire__builder__question__inputs__settings">
                        <MatrixEditOptions questionData={props.questionData} idx={props.idx}/>
                    </div>
                </div>
            </div>
            { !hasReachedMaximumOptions &&
                <div className="questionaire__builder__question__subtitle questionaire__builder__col1">
                    <a className="questionaire__builder__question__subtitle__action"
                       href="#" onClick={onClickAddAnswer}>+ Add new answer</a>
                </div>
            }
        </React.Fragment>
    );
}

export default MatrixColumnsChoiceEdit;